import { Info } from 'lucide-react';
import { joinCss } from '@/shared/lib/css-utils';
import { Skeleton, Tooltip } from '@/shared/ui';
import css from './filter-count-card.module.scss';

type FilterCountCardProps = {
  label: string;
  subText: string;
  dot: string;
  count: number | undefined;
  active: boolean;
  /** Amber aging-hint styling for the sub-text (design cards 1 & 2). */
  agingHint?: boolean;
  /** Info-tooltip copy: what the number counts + what clicking filters (XT-341). */
  description?: string;
  /** The resolved operations.list query this card's filter+window applies (XT-341). */
  query?: string;
  onClick: () => void;
};

export const FilterCountCard = ({
  label,
  subText,
  dot,
  count,
  active,
  agingHint,
  description,
  query,
  onClick,
}: FilterCountCardProps) => (
  <button
    aria-label={`${label}${count === undefined ? '' : ` (${count})`}`}
    aria-pressed={active}
    className={joinCss(css.root, active && css.rootIsActive)}
    onClick={onClick}
    type="button"
  >
    <span className={css.dot} style={{ backgroundColor: dot }} />
    <span className={css.count}>
      {count === undefined ? <Skeleton height={19} width={24} /> : count}
    </span>
    <span className={css.text}>
      <span className={css.label}>{label}</span>
      <span className={joinCss(css.sub, agingHint && css.subIsAging)}>
        {subText}
      </span>
    </span>
    {description && (
      <Tooltip
        content={
          <>
            <div>{description}</div>
            {query && <div className={css.tooltipQuery}>{query}</div>}
          </>
        }
        onClick={(e) => e.stopPropagation()}
        position="bottom"
      >
        <Info aria-label={`About ${label}`} className={css.infoIcon} />
      </Tooltip>
    )}
  </button>
);
